import { motion } from "framer-motion";

const articles = [
    {
      publication: "Tech Trail",
      title: "Building an AI System Taught Me It’s Not About the Model",
      link: "https://techtrail.tuhindutta.com/building-an-ai-system-taught-me-it-s-not-about-the-model",
      description: "A shift from using LLM APIs to designing modular, scalable AI systems with proper architecture and control."
    },
    {
      publication: "Tech Trail",
      title: "Concurrency in Python",
      link: "https://techtrail.tuhindutta.com/concurrency-in-python",
      description: "Explaining Python’s concurrency models with clarity, context, and real understanding.",
    },
    {
      publication: "Tech Trail",
      title: "Zenalyze: My AI-Assisted Data Analysis Tool (And Why I Built It)",
      link: "https://techtrail.tuhindutta.com/zenalyze-ai-assisted-data-analysis-tool",
      description: "Creating an AI-powered library to handle the boilerplate while you focus on the fun part of analysis.",
    },
    {
      publication: "Tech Trail",
      title: "Machine Learning Experimentation with Airflow",
      link: "https://techtrail.tuhindutta.com/machine-learning-experimentation-with-airflow",
      description: "Creating a framework to auto-setup Airflow celery deployment with custom packages for ML experimentation.",
    },
    {
      publication: "Tech Trail",
      title: "Testing the Nutriguide API",
      link: "https://techtrail.tuhindutta.com/testing-the-nutriguide-api",
      description: "Nutriguide API in action, setting up and testing the Nutriguide API, using its endpoints to provide health and product data, interact with the LLM chatbot, and view context-aware conversation examples.",
    },
    {
      publication: "Tech Trail",
      title: "Testing the Smart Nutrition API: Accuracy, Validation, and Usage",
      link: "https://techtrail.tuhindutta.com/testing-smart-nutrition-api",
      description: "Evaluated the smart nutrition API that extracts nutritional data from product images with ~3% error, highlighting usage and reliability.",
    },
    {
      publication: "Tech Trail",
      title: "Speech Refiner – Voice-to-Politeness AI Tool",
      link: "https://techtrail.tuhindutta.com/speech-refiner",
      description: "An AI-powered web app that converts recorded speech into professionally refined text using LLMs, designed for clear and courteous communication.",
    },
    {
      publication: "Statistically Speaking",
      title: "Boosting Machine Learning Adaboost Guide",
      link: "https://statisticallyspeaking.tuhindutta.com/boosting-machine-learning-adaboost-guide",
      description: "A step-by-step guide to boosting, with mathematical derivations and code examples to build intuition from the ground up.",
    },
    {
      publication: "Statistically Speaking",
      title: "Understanding the Sigmoid Function and Its Applications in Machine Learning",
      link: "https://statisticallyspeaking.tuhindutta.com/understanding-sigmoid-function-applications-machine-learning",
      description: "A mathematical deep dive into the sigmoid function, its properties, and real-world applications in machine learning and neural networks.",
    },
    {
      publication: "Critical Mind",
      title: "The Concept of Clustering in Unsupervised Learning",
      link: "https://criticalmind.tech.blog/2021/08/23/concept-of-clusters/",
      description: "An in-depth exploration of clustering algorithms, covering the intuition, math, and applications behind grouping data without labels.",
    },
    {
      publication: "Statistically Speaking",
      title: "Unveiling the Power of Support Vector Machines in Classification Tasks",
      link: "https://statisticallyspeaking.tuhindutta.com/unveiling-the-power-of-support-vector-machines-in-classification-tasks",
      description: "A comprehensive introduction to SVMs, explaining margin maximization, hyperplanes, and kernel tricks through mathematical intuition and visual examples.",
    },
    {
      publication: "Critical Mind",
      title: "Overfitting in Machine Learning: Causes and Solutions",
      link: "https://criticalmind.tech.blog/2021/07/27/why-overfitting-an-issue/",
      description: "An insightful look into why overfitting occurs, how it impacts model performance, and practical techniques to prevent it using regularization, cross-validation, and more.",
    },
  ];

function Articles() {
  const publications = ["Tech Trail", "Statistically Speaking", "Critical Mind"];

  return (
    <section
      id="articles"
      name="articles"
      className="bg-articles bg-gray-100 text-gray-800 px-6 py-16 min-h-screen"
    >
      <div className="site-container max-w-4xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6 text-center">
          <u>Publications & Articles</u>
        </h2>

        <div className="space-y-10">
          {publications.map((publication) => (
            <section key={publication} aria-labelledby={`publication-${publication.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="mb-4 flex items-center gap-3 border-b border-gray-300 pb-2">
                <h3
                  id={`publication-${publication.replace(/\s+/g, "-").toLowerCase()}`}
                  className="text-sm font-semibold uppercase tracking-wider text-gray-600"
                >
                  {publication}
                </h3>
                <span className="text-xs text-gray-500">
                  {articles.filter((article) => article.publication === publication).length} articles
                </span>
              </div>
              <div className="space-y-3">
                {articles
                  .filter((article) => article.publication === publication)
                  .map((item, index) => (
                    <motion.article
                      key={item.title}
                      initial={{ opacity: 0, y: 12 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, amount: 0.15 }}
                      transition={{ duration: 0.35, delay: Math.min(index * 0.04, 0.16) }}
                      className="tile-color p-5 sm:p-6"
                    >
                      <h4 className="text-lg font-semibold leading-snug text-blue-800">
                        {item.title}
                      </h4>
                      <p className="mt-2 text-sm leading-relaxed text-gray-700">
                        {item.description}
                      </p>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-blue-700 hover:text-blue-900"
                      >
                        Read article <span aria-hidden="true">↗</span>
                      </a>
                    </motion.article>
                  ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Articles;
